import { AsyncPipe, CurrencyPipe, NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { PaymentCardFormComponent } from '@components/consultation-request/payment-card-form/payment-card-form.component';
import { PaymentSubmitButtonComponent } from '@components/consultation-request/payment-submit-button/payment-submit-button.component';
import { MycoplasmaBaseComponent } from '@components/mycoplasma-base/mycoplasma-base.component';
import { MycoplasmaHominisUreaplasmaUpsell } from '@data/tests';
import { MycoplasmaTypes } from '@enums/mycoplasma-types';
import { OrderUpsell } from '@models/order-upsell';
import { ImageFallback } from '@pipes/image-fallback';
import { provideDefaultPaymentConfig } from '@services/payment.service';

@Component({
  selector: 'app-mycoplasma-hominis-ureaplasma',
  imports: [
    NgIf,
    CardComponent,
    NgFor,
    NgClass,
    PaymentCardFormComponent,
    PaymentSubmitButtonComponent,
    AsyncPipe,
    CurrencyPipe,
    ImageFallback,
    NgOptimizedImage,
  ],
  templateUrl: '../mycoplasma-base/mycoplasma-base.component.html',
  styleUrls: ['../mycoplasma-base/mycoplasma-base.component.scss', './mycoplasma-hominis-ureaplasma.component.scss'],
  providers: [provideDefaultPaymentConfig()],
})
export class MycoplasmaHominisUreaplasmaComponent extends MycoplasmaBaseComponent implements OnInit {
  public override readonly mycoplasmaTest: OrderUpsell = MycoplasmaHominisUreaplasmaUpsell;

  /**
   * Initializes the component.
   *
   * Fetches the Mycoplasma Hominis Ureaplasma content and displays it.
   */
  public ngOnInit(): void {
    this.getMycoplasmaContent(MycoplasmaTypes.HominisUreaplasma);
  }
}
